<template>
  <div class="mt-2">
    <v-container style="margin-right: 0; margin-left: 0;" v-if="user.roles && user.roles.includes('*')">
      <v-row style="height: 100%;" class="pl-2">
        <v-col md="6" class="pr-0">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>Users</h4>
          </v-toolbar>
          <Users @rowClicked="onUserRowClicked"/>
        </v-col>
        <v-col md="6">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>User Permissions</h4>
          </v-toolbar>
          <UserPermissions :userEditObj="userEditObj" :isEditing="isEditUser" @finished="isEditUser = false, userEditObj ={}"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Users from '../components/Users'
  import UserPermissions from '../components/UserPermissions'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    components: {
      Users,
      UserPermissions
    },
    async mounted () {
      await this.fetchRoles()
      await this.fetchUserWithRoles()
      if (this.user.roles && !this.user.roles.includes('*')) {
        this.$router.push('/')
      }
    },
    data: () => ({
      userEditObj: {},
      isEditUser: false
    }),
    computed: {
      ...mapGetters(['getUserLoggedIn']),
      user () {
        return this.getUserLoggedIn
      }
    },
    methods: {
      ...mapActions(['fetchRoles', 'fetchUserWithRoles']),
      onUserRowClicked(rowData){
        this.userEditObj = rowData
        this.isEditUser = true
      }
    }
  }
</script>

<style scoped>
  @media (min-width: 1264px) {
    .container {
      max-width: 100%;
    }
  }
</style>
